import { atom } from "jotai"

export const cropAspectLockAtom = atom(true)
export const cropStraightenGridAtom = atom(false)
